var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('p',[_vm._v("「人物」タブでタグ付けされた人物の一覧が表示されます（現在"+_vm._s(_vm.count)+"人）。")]),_c('v-row',_vm._l((_vm.people),function(value,key){return _c('person-card',{key:key,attrs:{"personId":key,"annos":value}})}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }